const FONT_WEIGHT_CSS: Record<'normal' | 'bold', number> = {
    normal: 400,
    bold: 700,
};

export const resolveBrandFontWeightVar = (weight: string | undefined): number | 'inherit' => {
    if (weight && weight in FONT_WEIGHT_CSS) {
        return FONT_WEIGHT_CSS[weight as 'normal' | 'bold'];
    }
    return 'inherit';
};
